import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { Adal } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: Adal = {
  instance: '',
  tenant: '',
  clientId: '',
  redirectUri: '',
  resources: {
    yammer: '',
    yammerTeams: '',
    graph: '',
    loki: '',
    substrateNotifications: '',
    substratePushSubscription: '',
    ocps: '',
  },
  validAuthRedirectUris: [],
};

const reducer: Reducer<Adal, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.adal;
    default:
      return state;
  }
};

export default reducer;
